<template>
  <div
    class="exp-item-cont"
    :class="{ mobile }"
    :aria-expanded="isOpen ? 'true' : 'false'"
  >
    <div class="exp-item" @click="isOpen = !isOpen">
      <div class="exp-title">
        <div class="icon">
          <v-icon size="28" :class="{ isOpen }">
            mdi-chevron-down
          </v-icon>
        </div>
        <div v-html="title"></div>
      </div>
    </div>

    <div
      class="item-cont"
      :class="{ isOpen }"
      :aria-hidden="isOpen ? 'false' : 'true'"
    >
      <div class="item-cont-padd">
        <article
          v-for="item in itemsList"
          :key="item.question"
          class="item"
          @click.stop
        >
          <div
            class="bold-500 question"
            @click="item.isOpen = !item.isOpen"
            :aria-expanded="item.isOpen ? 'true' : 'false'"
          >
            <div class="icon">
              <v-icon size="28" :class="{ isOpen: item.isOpen }">
                mdi-chevron-down
              </v-icon>
            </div>
            <div>{{ item.question }}</div>
          </div>
          <div
            class="answer"
            :class="{ isOpen: item.isOpen }"
            :aria-hidden="item.isOpen ? 'false' : 'true'"
          >
            <div v-html="item.answer" class="answer-text" />
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LibHomeMultiExpandedItem",
  props: {
    title: { type: String, default: "" },
    items: { type: Array, default: () => [] },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      itemsList: []
    };
  },
  mounted() {
    this.itemsList = this.items.map((item) => ({ ...item, isOpen: false }));
  }
};
</script>

<style lang="scss" scoped>
.exp-item {
  text-decoration: none;
  border: 1px solid var(--c-primary-blue);
  border-radius: 16px;
  padding: 15px 14px;
  cursor: pointer;
  box-sizing: border-box;
  transition: 0.1s box-shadow;
  .v-icon {
    color: var(--c-primary-blue);
    transition: 0.3s all;
    &.isOpen {
      transform: rotate(180deg);
    }
  }
  &:hover {
    box-shadow: inset 0px 0px 0px 2px var(--c-primary-blue);
  }
  .exp-title {
    color: var(--c-primary-purple);
    font-weight: 500;
    font-size: 1.125rem;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.item-cont {
  overflow: hidden;
  max-height: 0px;
  transition: all 0.5s;
  opacity: 0;

  &.isOpen {
    max-height: 60000px;
    opacity: 1;
  }
  .item {
    padding: 0px 15px 0px 46px;
    cursor: auto;
    &:last-child .answer-text {
      padding-bottom: 0px;
    }
  }
  .question {
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin: 4px 0;
  }
  .v-icon {
    color: rgb(61, 61, 64);
    transition: 0.3s all;
    &.isOpen {
      transform: rotate(180deg);
    }
  }
  .answer {
    padding-left: 6px;
    overflow: hidden;
    max-height: 0px;
    transition: all 0.5s;
    opacity: 0;
    // .answer-text {
    //   padding-bottom: 16px;
    // }

    &.isOpen {
      max-height: 60000px;
      opacity: 1;
    }
  }
}

.item-cont-padd {
  padding: 8px 0 0 0;
}

.exp-item-cont.mobile {
  .item {
    padding: 0px 0px 0px 6px;
  }
}

.mobile {
  .exp-title {
    font-size: 1rem;
  }
}
</style>
